import { WithStyles, withStyles } from '@material-ui/core';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { postLiveComposition } from './requests';
import { styles } from './styles';
import {IRootState} from "../../../typings";

interface IOwnProps {}

const mapDispatchToProps = {
  postLiveComposition,
};

const mapStateToProps = (state: IRootState) => ({
  mainCommentatorLocale: state.live.mainCommentatorLocale
});

export type IComponentProps = typeof mapDispatchToProps &
  ReturnType<typeof mapStateToProps> &
  InjectedIntlProps &
  WithStyles &
  IOwnProps;

const reduxConnector = connect(
  mapStateToProps,
  mapDispatchToProps
);

export const connector = compose<IComponentProps, IOwnProps>(
  reduxConnector,
  injectIntl,
  withStyles(styles)
);
